<template>
  <div class="func-customizada-termo-uso">
    <TermosDeUsoComponent
      class="termo-uso-comp"
      :idTermo="idTermo"
      :titulo="titulo"
      :button-voltar="false"
      :buttons-footer="true"
      :esconder-header="false"
      @aceito="aceito"
      @dataAceite="bypass"
      @cancelar="voltar"
      @voltar="voltar"
    />
  </div>
</template>
<script>
import TermosDeUsoComponent from '@/components/TermosDeUso/TermosDeUsoComponent'

export default {
  name: 'FuncionalidadeCustomizadaTermoDeUso',
  components: { TermosDeUsoComponent },
  props: {
    idTermo: {
      type: [Number, String]
    },
    titulo: {
      type: String
    }
  },
  methods: {
    aceito (payload) {
      this.$emit('aceito', { aceite: payload })
    },
    bypass (payload) {
      if (payload) {
        this.$emit('aceito', {
          aceite: payload,
          bypass: true
        })
      }
    },
    voltar () {
      this.$emit('voltar')
    }
  },
  destroyed () {
    this.$emit('close')
  }
}
</script>
<style scoped>
.func-customizada-termo-uso {
  display: flex;
  padding: 20px;
  height: calc(100vh - 80px);

  .termo-uso-comp {
    overflow-y: scroll;
    border: 1px solid #EEEEEE;
    border-radius: 5px;
    height: calc(100vh - 120px);
  }
}
</style>
